import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NightShiftNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const [value, setValue] = useState("/night-shift/schedule");

  useEffect(() => {
    const path = location.pathname;
    if (path === "/night-shift" || path === "/night-shift/schedule") {
      setValue("/night-shift/schedule");
    }
  }, [location.pathname]);

  const tabs = [
    { path: "/night-shift/schedule", label: t("nightShift.nav.schedule", "Schedule") },
  ];

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{ ml: "5px", "& .MuiTabs-indicator": { display: "none" } }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.path}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor: value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
};

export default NightShiftNav;
